import React, { useState, useEffect } from "react";
import { withRouter } from "react-router-dom";
import { compose } from "redux";
import { connect } from "react-redux";
import moment from "moment";
import { isEmpty } from "lodash";
import { ButtonIcon } from "@loanbossinc/component-library";
import { SimpleInfoModal } from "modals/SimpleInfoModal";
import { nullLiteralTypeAnnotation } from "@babel/types";

import {
  getCountryCodes,
  getHolidays,
  getHolidayById,
  getAllByCountry,
  getHolidayByDate,
  addHoliday,
  updateHoliday,
  refreshHolidays,
  refreshHolidayDateRange,
  refreshSingleHoliday,
  deleteHoliday
} from "./holidayCalendar.store";
import { TableWrapper, StyledButtonText, ButtonWrapper, TopButtonWrapper, StyledSubText, CellContentWrapper, PageTitle } from "./holidayCalendar.style";
import HolidayDataTable from "./HolidayDataTable";
import TextFilter from "./TextFilter";
import SelectFilter from "./SelectFilter";
import DateFilter from "./DateFilter";
import AddEditHolidayModal from "./AddEditHolidayModal";
import RefreshHolidayModal from "./RefreshHolidayModal";

const HolidayCalendar = props => {
  const { countryCodes, holidays, getHolidays, deleteHoliday, refreshHolidayDateRange, updateHoliday, getCountryCodes, addHoliday, refreshSingleHoliday } = props;

  const [showFilter, setShowFilter] = useState(false);
  const [showNewHoliday, setShowNewHoliday] = useState(false);
  const [simpleConfirmState, setSimpleConfirmState] = useState({
    showSimpleInfoModal: false,
    confirmTitle: "",
    confirmMessage: "",
    confirmFunction: null,
    cancelFunction: null
  });
  const [editAddState, setEditAddState] = useState({
    isEdit: true,
    holidayToEdit: null,
    showModal: false,
    save: null,
    cancel: null,
    reset: null
  });
  const [refreshHolidayState, setRefreshHolidayState] = useState({
    updateParams: {
      yearFrom: null,
      yearTo: null,
      cityId: null,
      overwriteExisting: false
    },
    showModal: false,
    save: null,
    cancel: null
  });

  useEffect(() => {
    getCountryCodes();
    getHolidays();
  }, []);

  const editHoliday = item => {
    const foundItems = holidays.filter(x => x.id === item);
    if (foundItems && foundItems.length > 0) {
      setEditAddState(prevValues => ({
        isEdit: true,
        holidayToEdit: foundItems[0],
        showModal: true,
        save: item => {
          if (!item.manualEntry) {
            item.hasOverride = true;
          }
          if (item.observed === "") {
            item.observed = null;
          }

          updateHoliday({
            holiday: item,
            callback: () => {
              setEditAddState(!prevValues.showModal);
              getHolidays();
            }
          });
        },
        cancel: () => {
          setEditAddState(!prevValues.showModal);
        },
        reset: item => {
          refreshSingleHoliday({
            holiday: foundItems[0],
            callback: () => {
              setEditAddState(!prevValues.showModal);
              getHolidays();
            }
          });
        }
      }));
    }
  };
  const deleteHolidayConfirm = item => {
    setSimpleConfirmState(prevValues => ({
      showSimpleInfoModal: !prevValues.showSimpleInfoModal,
      confirmTitle: "Delete Holiday",
      confirmMessage: "Are you sure you want to delete this holiday? This Cannot be undone.",
      confirmFunction: () => {
        doDelete(item);
      },
      cancelFunction: () => {
        deleteHolidayConfirm(null);
      }
    }));
  };
  const addNewHoliday = () => {
    setEditAddState(prevValues => ({
      isEdit: false,
      holidayToEdit: {
        cityId: null,
        date: null,
        hasOverride: false,
        holidayName: "",
        manualEntry: true,
        observed: null
      },
      showModal: true,
      save: item => {
        addHoliday({
          holiday: item,
          callback: () => {
            setEditAddState(!prevValues.showModal);
            getHolidays();
          }
        });
      },
      cancel: () => {
        setEditAddState(!prevValues.showModal);
      }
    }));
  };
  const refreshFromService = () => {
    setRefreshHolidayState(prevValues => ({
      updateParams: {
        yearFrom: null,
        yearTo: null,
        cityId: null,
        overwriteExisting: false
      },
      showModal: true,
      save: item => {
        refreshHolidayDateRange(
          {
            cityId: item.cityId,
            yearStart: item.yearFrom,
            yearEnd: item.yearTo,
            overwriteExisting: item.overwriteExisting,
            callback: () => {
              if (showFilter) {
                setShowFilter(!showFilter);
              }
              setRefreshHolidayState(!prevValues.showModal);
              getHolidays();
            }
          }
        );
      },
      cancel: () => {
        setRefreshHolidayState(!prevValues.showModal);
      }
    }));

    if (showFilter) {
      setShowFilter(!showFilter);
    }
  };
  const doDelete = item => {
    deleteHoliday({ id: item, callback: getHolidays });
    deleteHolidayConfirm(null);
    if (showFilter) {
      setShowFilter(!showFilter);
    }
  };
  const columns = [
    {
      Header: "Holiday Data",
      columns: [
        {
          accessor: "city.name",
          sortType: "basic",
          Header: "Country",
          Filter: SelectFilter,
          Cell: item => (
            <CellContentWrapper>
              {item.value}
            </CellContentWrapper>
          )
        },
        { accessor: "holidayName", sortType: "basic", Header: "Holiday Name", Filter: SelectFilter },
        {
          accessor: "date",
          sortType: "basic",
          Header: "Date",
          Filter: DateFilter,
          filter: "dateBetween",
          Cell: item => (
            <CellContentWrapper>
              {moment(item.value).format("MM/DD/YYYY")}
            </CellContentWrapper>
          )
        },
        {
          accessor: "observed",
          sortType: "basic",
          Header: "Observation Date",
          Filter: DateFilter,
          filter: "dateBetween",
          Cell: item => (
            <CellContentWrapper>
              {item.value && moment(item.value).format("MM/DD/YYYY")}
              {item.row.original.hasOverride && (<StyledSubText>Manual Override</StyledSubText>)}
            </CellContentWrapper>
          )
        },
        {
          accessor: "id",
          Cell: item => (
            <ButtonWrapper>
              <ButtonIcon hasBorder={false} iconName="edit" onClick={data => editHoliday(item.value)} />
              <ButtonIcon disabled={!item.row.original.manualEntry} hasBorder={false} iconName="delete" onClick={data => deleteHolidayConfirm(item.value)} />
            </ButtonWrapper>
          )
        }
      ]
    }
  ];

  return (
    <div>
      <SimpleInfoModal
        title={simpleConfirmState.confirmTitle}
        isOpen={simpleConfirmState.showSimpleInfoModal}
        onClose={simpleConfirmState.cancelFunction}
        onAccept={simpleConfirmState.confirmFunction}
        content={simpleConfirmState.confirmMessage}
      />
      <AddEditHolidayModal
        title={editAddState.isEdit ? "Edit Holiday" : "Add Holiday"}
        isOpen={editAddState.showModal}
        onClose={editAddState.cancel}
        onreset={editAddState.reset}
        onAccept={editAddState.save}
        holiday={editAddState.holidayToEdit}
        isEdit={editAddState.isEdit && editAddState.holidayToEdit && !editAddState.holidayToEdit.manualEntry}
        countryCodes={countryCodes.sort((a, b) => a.name.localeCompare(b.name))}
      />
      <RefreshHolidayModal
        title={"Refresh Holidays From API"}
        isOpen={refreshHolidayState.showModal}
        onClose={refreshHolidayState.cancel}
        onAccept={refreshHolidayState.save}
        updateParams={refreshHolidayState.updateParams}
        countryCodes={countryCodes.sort((a, b) => a.name.localeCompare(b.name))}
      />
      <div>
        <PageTitle>Cashflow Holiday Calendar Settings</PageTitle>
        <TopButtonWrapper style={{ flexBasis: "50%", flex: "0 1 auto" }}>
          <StyledButtonText
            onClick={() => {
              setShowFilter(!showFilter);
            }}
            iconName="filter_list"
            label={!showFilter ? "Filter Table" : "Clear Filter"}
            reverse
          />
          <div>
            <StyledButtonText
              onClick={() => {
                addNewHoliday();
              }}
              iconName="add_circle"
              label="Add Custom Holiday"
              reverse
            />
            <StyledButtonText
              onClick={() => {
                refreshFromService();
              }}
              iconName="refresh"
              label="Refresh Public Holidays"
              reverse
            />

          </div>
        </TopButtonWrapper>
        <TableWrapper>
          <HolidayDataTable columns={columns} data={holidays} showFilter={showFilter} />
        </TableWrapper>
      </div>
    </div>);
};

const mapStateToProps = ({ authentication, holidayCalendar }) => ({
  authentication,
  ...holidayCalendar
});

export default compose(
  withRouter,
  connect(mapStateToProps, {
    getCountryCodes,
    getHolidays,
    getHolidayById,
    getAllByCountry,
    getHolidayByDate,
    addHoliday,
    updateHoliday,
    refreshHolidays,
    refreshHolidayDateRange,
    refreshSingleHoliday,
    deleteHoliday
  })
)(HolidayCalendar);
